<button mat-icon-button (click)="clicked.emit()" [disabled]="disabled" style="border-radius: 5px; display:flex; align-items: center; justify-content: center;"
    [style.height]="height" [ngClass]="{'hide-background': background === 'none'}">
    <i class="{{icon}}" [style.fontSize]="size"
        [ngClass]="{'single-color-icon':!disabled && type === 'action', 'icon': !disabled && type === 'default','disabled': disabled}"></i>
</button>